import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Snackbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { setUserId } from "../../Redux/actions";
import axios from "axios";
import { Toast } from "primereact/toast";
import bgImage from "../../assets/img/login_bg.svg";
import logoSmartHire from "../../assets/img/logo_smartHire.svg";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useTranslation } from "react-i18next";
import colors from "colors/color";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import new_logo from "../../assets/img/new_logo.svg";
import { NewPostButton } from "../../components/Buttons/Buttons";
import arrow_back_icon from "../../assets/img/arrow_back_icon.svg";

const LoginPage = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [authMode, setAuthMode] = useState("signin");
  const toast = useRef(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [captchaRequired, setCaptchaRequired] = useState(false);
  const [browserFingerprint, setBrowserFingerprint] = useState("");
  const recaptchaRef = useRef(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const linkedInClientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID || "86dpwd87p8nanb";
  const linkedInClientSecret = process.env.REACT_APP_LINKEDIN_CLIENT_SECRET || "vZYhlaKOFW1tqXhk";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get("redirect");
    if (redirect) {
      setRedirectUrl(decodeURIComponent(redirect));
    }
  }, []);

  useEffect(() => {
    if (location.state?.authMode === "signup") {
      setAuthMode("signup");
    }
  }, [location.state]);

  useEffect(() => {
    const jobData = localStorage.getItem("job");
    localStorage.clear();

    if (jobData !== null) {
      localStorage.setItem("job", jobData);
      // navigate("/application_page", { state: { job: jobData } });
    }
  }, []);

  useEffect(() => {
    if (window.location.href.includes("code=")) {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      fetchCallbackData(code);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const contentHeight = 700; // Approximate height of your content
      const contentWidth = 400; // Max width of your content

      // Calculate scale based on both height and width
      const heightScale = (windowHeight * 0.9) / contentHeight; // 90% of window height
      const widthScale = (windowWidth * 0.9) / contentWidth; // 90% of window width

      // Use the smaller scale to ensure content fits both dimensions
      const newScale = Math.min(heightScale, widthScale, 1);
      setScale(newScale);
    };

    handleResize(); // Initial scale
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };
  const redirectToDashboardcandidate = () => {
    // If there's a saved redirect URL, use it, otherwise go to default dashboard
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/dashboard"); // Or whatever your default dashboard path is
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const toggleAuthMode = () =>
    setAuthMode(authMode === "signin" ? "signup" : "signin");

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const fingerprint = result.visitorId;
        setBrowserFingerprint(fingerprint);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}authentication/check-captcha-status/`,
          {
            params: {
              browserFingerprint: fingerprint,
            },
          }
        );

        setCaptchaRequired(response.data.captcha_required);
      } catch (error) {
        console.error("Error during initialization:", error);
        setCaptchaRequired(false);
      } finally {
        setIsLoading(false);
      }
    };

    initializeComponent();
  }, []);

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return null;

    try {
      const decodedToken = parseJwt(accessToken);
      return decodedToken.user_id;
    } catch (error) {
      console.error("Failed to decode token:", error);
      return null;
    }
  }

  function parseJwt(token) {
    try {
      if (!token || typeof token !== 'string') {
        throw new Error('Invalid token format');
      }

      const parts = token.split(".");
      if (parts.length !== 3) {
        throw new Error('Invalid JWT structure');
      }

      const base64Url = parts[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('JWT parsing error:', error);
      throw error;
    }
  }

  const redirectToAdminA = () => navigate("/manager/ListRecruiter");
  const redirectToDashboard = () => navigate("/talent/dashboard");
  const redirectToSuperAdmin = () => navigate("/superadmin/dashboard");
  const redirectToHome = () => {
    const job = localStorage.getItem("job");
    if (job) {
      try {
        const jobData = JSON.parse(job);
        navigate("/application_page", { state: { job: jobData, cameFromLogin: true } });
      } catch (error) {
        console.error("Error parsing job data:", error);
        navigate("/landing");
      }
    } else {
      navigate("/landing");
    }
  };

  // Centralized role-based redirect function
  const handleRoleBasedRedirect = (userRole) => {
    if (redirectUrl) {
      navigate(redirectUrl);
      return;
    }

    switch (userRole) {
      case "r":
        redirectToDashboard();
        break;
      case "a":
        redirectToAdminA();
        break;
      case "s":
        redirectToSuperAdmin();
        break;
      default:
        redirectToHome();
    }
  };

  const handleSignInSuccess = (response) => {
    localStorage.setItem("accessToken", response.data.access_token);
    localStorage.setItem("refreshToken", response.data.refresh_token);
    if (response.data.user.image) {
      localStorage.setItem("userImage", response.data.user.image);
    }

    try {
      window.dispatchEvent(new Event('auth-token-changed'));
    } catch (error) {
      console.error('Error dispatching auth-token-changed event:', error);
    }

    const userId = getUserIdFromAccessToken();
    if (userId) {
      try {
        localStorage.setItem('userId', String(userId));
      } catch (error) {
        console.error('Error saving userId to localStorage:', error);
      }
      props.setUserId(userId);
    }

    handleRoleBasedRedirect(response.data.user.role);

    setSnackbar({
      open: true,
      message: t("login.success.login_success"),
      severity: "success",
    });
  };

  const handleSignUpSuccess = () => {
    setSnackbar({
      open: true,
      message: t("registration.success.message"),
      severity: "success",
    });
    toggleAuthMode();
  };

  const fetchCallbackData = async (code) => {
    try {
      const params = {
        grant_type: "authorization_code",
        code: code,
        redirect_uri: `${apiUrl}login`,
        client_id: linkedInClientId,
        client_secret: linkedInClientSecret,
      };
      const response = await axios.get(
        `${apiUrl}authentication/linkedin-callback/`,
        { params: params }
      );
      localStorage.setItem("accessToken", response.data.access_token);
      localStorage.setItem("refreshToken", response.data.refresh_token);
      if (response.data.user.image) {
        localStorage.setItem("userImage", response.data.user.image);
      }

      try {
        window.dispatchEvent(new Event('auth-token-changed'));
      } catch (error) {
        console.error('Error dispatching auth-token-changed event:', error);
      }

      const userId = getUserIdFromAccessToken();
      if (userId) {
        try {
          localStorage.setItem('userId', String(userId));
        } catch (error) {
          console.error('Error saving userId to localStorage:', error);
        }
        props.setUserId(userId);
      }

      handleRoleBasedRedirect(response.data.user.role);
    } catch (error) {
      console.error("Error fetching callback data:", error);
    }
  };

  const handleGoogleSuccess = async (res) => {
    try {
      const response = await axios.get(
        `${apiUrl}authentication/google/userinfo/`,
        { withCredentials: true, params: res.profileObj }
      );
      localStorage.setItem("accessToken", response.data.access_token);
      localStorage.setItem("refreshToken", response.data.refresh_token);
      if (response.data.user.image) {
        localStorage.setItem("userImage", response.data.user.image);
      }

      try {
        window.dispatchEvent(new Event('auth-token-changed'));
      } catch (error) {
        console.error('Error dispatching auth-token-changed event:', error);
      }

      const userId = getUserIdFromAccessToken();
      if (userId) {
        try {
          localStorage.setItem('userId', String(userId));
        } catch (error) {
          console.error('Error saving userId to localStorage:', error);
        }
        props.setUserId(userId);
      }

      handleRoleBasedRedirect(response.data.user.role);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleLinkedInAuth = () => {
    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${linkedInClientId}&redirect_uri=${window.location.origin}/login&state=1234&scope=openid%20email%20profile`;
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        overflow: "hidden",
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      }}
    >
      <Toast ref={toast} />

      <Grid
        container
        sx={{
          display: "flex",
          height: "100%",
          width: "100%",
          m: 0,
          p: 0,
          position: "relative"
        }}
      >
        {/* Left side - Login form */}
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: { xs: 2, sm: 3, md: 4 },
            height: "100%",
            width: "100%",
            overflow: "hidden",
            position: "relative"
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "500px",
              position: "relative",
              transform: `scale(${scale})`,
              transformOrigin: "center center",
              transition: "transform 0.3s ease-in-out",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            {isMobile && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  padding: "20px",
                  zIndex: 1000,
                }}
              >
                <img src={new_logo} alt="logo" style={{ maxWidth: "100%", height: "auto" }} />
              </Box>
            )}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 4, mt: -2, width: '100%' }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '17px',
                  marginBottom: '30px',
                  width: '100%',
                  cursor: 'pointer'
                }}
                  onClick={() => navigate("/landing")}
                >
                  <img
                    src={logoSmartHire}
                  alt="TalentyHire"
                    style={{
                      width: '174px',
                      height: '32px'
                    }}
                  />
                </Box>
                {authMode === "signin" && (
                  <Box sx={{ mb: 3 }}>
                    <NewPostButton
                      startIcon={<img src={arrow_back_icon} alt="Home" style={{ marginRight: 8 }} />}
                      onClick={() => navigate("/landing")}
                      sx={{
                        minWidth: 120,
                        width: 'auto',
                        padding: '8px 16px',
                        height: '40px',
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        borderRadius: "11px",
                        border: "1px solid #0017E7",
                        color: "#0017E7",
                        background: "#fff",
                        textTransform: "none",
                        boxShadow: "none",
                        '&:hover': {
                          background: '#0017E7',
                          color: '#fff',
                          borderColor: '#0017E7',
                        },
                      }}
                    >
                      {t("navBar.home")}
                    </NewPostButton>
                  </Box>
                )}
                <Typography
                  sx={{
                    color: colors.primary,
                    fontSize: { xs: "32px", sm: "36px", md: "40px" },
                    fontFamily: "Kontora",
                    fontWeight: 700,
                    mb: 0.5,
                    width: { xs: "120px", sm: "140px", md: "160px" },
                    height: { xs: "35px", sm: "40px", md: "45px" },
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {authMode === "signin" ? t("login.sign_in") : t("registration.sign_up")}
                </Typography>
              </Box>
            </Grid>

            {authMode === "signin" ? (
              <SignIn
                browserFingerprint={browserFingerprint}
                captchaRequired={captchaRequired}
                recaptchaRef={recaptchaRef}
                toggleAuthMode={toggleAuthMode}
                onSignInSuccess={handleSignInSuccess}
                onGoogleSuccess={handleGoogleSuccess}
                onLinkedInAuth={handleLinkedInAuth}
                setSnackbar={setSnackbar}
                setCaptchaRequired={setCaptchaRequired}
                clientId={clientId}
              />
            ) : (
              <SignUp
                apiUrl={apiUrl}
                toggleAuthMode={toggleAuthMode}
                onSignUpSuccess={handleSignUpSuccess}
                onGoogleSuccess={handleGoogleSuccess}
                onLinkedInAuth={handleLinkedInAuth}
                setSnackbar={setSnackbar}
                clientId={clientId}
              />
            )}
          </Box>
        </Grid>

        {/* Right side - Background image (hidden on xs screens) */}
        <Grid
          item
          sx={{
            display: { xs: "none", sm: "block" }, // Hide on xs screens, show on sm and above
            p: 0,
            height: "100%",
            position: "relative",
            width: { sm: "100%", md: "50%" },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              bgcolor: "#1976d2",
              color: "white",
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {/* Logo Container */}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                p: { sm: 3, md: 4 },
                cursor: "pointer"
              }}
              onClick={() => navigate("/landing")}
            >

            </Box>

            {/* Text Container */}
            <Box sx={{ p: { sm: 3, md: 4 } }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  fontSize: { sm: "1.5rem", md: "2rem", lg: "2.25rem" },
                  lineHeight: 1.2,
                  fontFamily: "Poppins",
                  pr: { sm: 2, md: 6, lg: 8 },
                }}
              >
                {t("login.slogan")}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "rgba(255, 255, 255, 0)",
            color: "black",
            borderRadius: "50px",
            backdropFilter: "blur(3px)",
            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.5)",
          },
        }}
        message={snackbar.message}
      />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  userId: state.userId,
});

const mapDispatchToProps = {
  setUserId,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
